<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../wrappedFetch.js";
    import Spinner from "./components/spinner.svelte";
    import Header from "./components/header.svelte";
    import Message from "./components/message.svelte";
    import { validate } from "../components/validate-action";
    import Button from "./components/button.svelte";

    export let Id;

    let isPageLoading = true;
    let isButtonLoading = false;

    let LASelected, EstabSelected, booleanEstab = true;
    let attempts = 0, accepted = false;
    let Type;
    let details;
    let hasUSOAccount = false;
    let usoUsername;
    let form;

    let showSuccessMessage = false;

    onMount(async () => {
        accepted = true;
        getLAs();
        await getInviteDetails();
        isPageLoading = false;
    });

    const getInviteDetails = async () => {
        details = await wrappedFetch(
            "/api/UserInvite/RetrieveInviteDetails?guid=" + Id,
            { method: "get" }
        ).then((r) => r.json());

        if (details.id) {
            attempts = details.attempts;
            accepted = details.accepted;

            if (accepted) {
                Type = "Warning";
                errormsg =
                    "This invitation has already been accepted. Please get in contact with us if you are having trouble accessing your account.";
            }
            if (attempts == "3") {
                accepted = true;
                Type = "Warning";
                errormsg = "You have reached the total number of attempts";
            }
        }
        else{
        isPageLoading = false;
            accepted = true;
            errormsg =
                "You have selected an invalid link, or the link has expired";
        }
    };

    let las = [];
    const getLAs = async () => {
        let resp = await wrappedFetch("/api/uso/GetGroups", { method: "get" });
        las = await resp.json();
        return las;
    };

    let estabs = [];
    const getEstab = async (LAs) => {
        estabs = await RetrieveEstablisments(LAs);
    };

    async function RetrieveEstablisments(sGroupID) {
        booleanEstab = true;
        estabs = [];
        if (sGroupID > 0) {
            let resp = await wrappedFetch(
                "/api/uso/GetEstablishments?sgid=" + sGroupID,
                { method: "get" }
            );
            estabs = await resp.json();
            booleanEstab = false;
        }
        return estabs;
    }

    let errormsg = "";

    const handleSubmit = async () => {
        errormsg = "";

        if (!hasUSOAccount) usoUsername = "";

        var isValid = jQuery(form).valid();

        if (!isValid) return;
        isButtonLoading = true;
        let resp = await wrappedFetch(
            "/api/UserInvite/Accept?guid=" + Id + "&sid=" + EstabSelected + "&username=" + usoUsername,
            { method: "post" }
        )
        .then((r) => r.json())
        .catch(() => {
            Type = "Warning";
            errormsg = "Failed to update the invite";
        });
        isButtonLoading = false;

        if (resp.success) {
            showSuccessMessage = true;
        } else if (resp.attempts == 0) {
            Type = "Warning";
            errormsg = "You have reached the total number of attempts<br>";
            accepted = true;
        } else {
            errormsg = `The details do not match our records. You have ${resp.attempts} attempt(s)<br>`;
            Type = "Warning";
        }
    };
</script>

<svelte:head>
    <title>Invite | Wavenet Nimbus</title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else}
    <Header ShowOptions={false} />

    <main>
        <div class="d-flex flex-row">
            <div class="container main-content pt-3">
                <div class="row">
                    <div class="card mb-4" style="width:100%">
                        <div class="card-body with-table">
                            <div class="row mb-3">
                                <div class="col-12">
                                    <img src="/images/invite.jpg" width="100%" alt="Help image" />
                                </div>
                            </div>

                            <div class="row m-0 p-0">
                                {#if errormsg}
                                    <Message {Type} message={errormsg} />
                                {/if}
                            </div>

                            {#if !accepted}
                                {#if showSuccessMessage}
                                    <Message Type="Success">
                                        <div slot="header">Your invitation has been successfully accepted.</div>
                                        <div slot="content">
                                            <p>You will now be able to log into Wavenet Nimbus. Please log in with your Google/Microsoft account linked to your email address or your USO account if this option was selected.</p>
                                            <a href="/app" target="_self" class="btn btn-primary">Login</a>
                                        </div>
                                    </Message>
                                {:else}
                                    {#if attempts != "5"}
                                        <div class="row m-0 p-0">
                                            <div class="col-md-12">
                                                <h3>Invite</h3>
                                                <p>To accept your invitation to become an administrator on Wavenet Nimbus, please complete the form below. Once completed you will then be able to log in with your email address (if it’s a Google or Microsoft account) or a USO account if you enter your existing USO username.</p>
                                                <hr />
                                            </div>
                                        </div>
                                        <div class="row m-0 p-0">
                                            <div class="col-md-12">
                                                <h5>Contact Details</h5>
                                                <div class="form-group mb-4">
                                                    <div class="row">
                                                        <div class="col-md-4 mb-2">
                                                            <label class="labeldisabled">First name</label><br />
                                                            <input type="text" class="form-control" value={details.firstName} disabled />
                                                        </div>
                                                        <div class="col-md-4 mb-2">
                                                            <label class="labeldisabled">Last name</label><br />
                                                            <input type="text" class="form-control" value={details.lastName} disabled/>
                                                        </div>
                                                        <div class="col-md-4 mb-2">
                                                            <label class="labeldisabled">Email</label><br />
                                                            <input type="text" class="form-control" value={details.emailAddress} disabled />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <form bind:this={form} use:validate={{ rules: { usoUsername: "usoAccount", }, }} >
                                            <div class="row m-0 p-0">
                                                <div class="col-md-12">
                                                    <h5>Establishment Details</h5>
                                                    <div class="form-group mb-4">
                                                        <div class="row">
                                                            <div class="col-md-4 mb-2">
                                                                <select
                                                                    bind:value={LASelected}
                                                                    on:change={() =>
                                                                        getEstab(
                                                                            LASelected
                                                                        )}
                                                                    class="form-control"
                                                                    name="la"
                                                                    required
                                                                >
                                                                    <option value="">Select your Local Authority</option>
                                                                    {#each las as la}
                                                                        <option value={la.sGroupID}>{la.nameShort}</option>
                                                                    {/each}
                                                                </select>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <select
                                                                    bind:value={EstabSelected}
                                                                    class="form-control"
                                                                    disabled={booleanEstab}
                                                                    name="estab"
                                                                    required
                                                                >
                                                                    <option value="" >Select your School</option>
                                                                    {#each estabs as estab}
                                                                        <option value={estab.schoolID} >
                                                                            {#if estab.leaid.length > 0}
                                                                                {estab.estab}
                                                                                ({estab.leaid}-{estab.dfESID})
                                                                            {:else}
                                                                                {estab.estab}
                                                                            {/if}
                                                                        </option>
                                                                    {/each}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0  mb-4">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label
                                                            ><input
                                                                type="checkbox"
                                                                bind:checked={hasUSOAccount}
                                                            /> Do you have an existing
                                                            USO account?
                                                        </label>
                                                    </div>
                                                    {#if hasUSOAccount}
                                                        <div class="form-group">
                                                            <label for="usoUsername">USO username</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                name="usoUsername"
                                                                id="usoUsername"
                                                                placeholder="jsmith.123"
                                                                required
                                                                bind:value={usoUsername}
                                                            />
                                                        </div>
                                                    {/if}
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="col-md-12">
                                                    <div class="form-group mb-4">
                                                        <div class="row">
                                                            <div class="col-md-12 mb-2">
                                                                <Button
                                                                    buttonClass={"btn-primary"}
                                                                    bind:isLoading={isButtonLoading}
                                                                    buttonText={"Submit"}
                                                                    on:click={handleSubmit}
                                                                />
                                                                <!-- <button
                                                                class="btn btn-primary"
                                                                type="button"
                                                                on:click|preventDefault={handleSubmit}
                                                                >Submit</button> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="mt-3"><i><small>If anything is incorrect on this page or you have any difficulties, please do not hesitate to get in <a href="https://www.wavenet.co.uk/contact-us" target="_blank">contact</a>.</small></i></p>
                                                </div>
                                            </div>                                            
                                        </form>
                                    {/if}
                                {/if}
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
{/if}
